'use strict';

/**
 * NewsOverview
 *
 * @author Zorica Janjic <zorica.janjic@namics.com>
 */
T.Module.NewsOverview = T.createModule({

	_selectors: {
		newsItem: '[data-js-m-news-overview__item]',
		panel: '[data-js-o-accordion__panel]'
	},

	_stateClasses: {
		open: 'state-open',
		closed: 'state-closed',
		initiallyOpen: '[data-js-state-initially-open]'
	},

	_eventNames: {
		// Search as you type functionality of the filter
		filterChange: 'm-filter-change',
		searchClosed: 'm-filter-search-closed'
	},

	_newsFieldsSelectors: ['headline', 'subline'],

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.$items = this.$ctx.find(this._selectors.newsItem);
		this.$panels = this.$ctx.find(this._selectors.panel);

		this._events.on('t.sync', this.sync.bind(this));
		this._events.on(this._eventNames.filterChange, this.onFilterChange.bind(this));
		this._events.on(this._eventNames.searchClosed, this.onSearchClosed.bind(this));

		this.hasBeenInitialized = false;

		resolve();
	},
	sync: function sync() {
		if (!this.hasBeenInitialized) {
			this.generateLunrIndex();

			this.hasBeenInitialized = true;
		}
	},


	/**
  * Generate the lunr index for searching
  *
  * @returns {void}
  */
	generateLunrIndex: function generateLunrIndex() {
		var _this2 = this;

		var fields = this._newsFieldsSelectors;

		// add all fields to the lunr index
		this.lunr = lunr(function () {
			var _this = this;

			fields.map(function (field) {
				return _this.field(field);
			});
			this.ref('id');
		});

		// loop over all news items to generate the lunr document for every news item
		this.$items.each(function (index, element) {
			var $newsItem = $(element);
			var elementIndexObject = {};

			elementIndexObject.id = $newsItem.attr('id');

			fields.map(function (field) {
				var newsField = $newsItem.find('[data-js-m-news-overview__' + field + ']');
				elementIndexObject[field] = newsField.text();

				return false;
			});

			_this2.lunr.add(elementIndexObject);
		});
	},
	closeAccordions: function closeAccordions() {
		var _this3 = this;

		this.$panels.map(function (index, element) {
			var $panel = $(element);
			return _this3.closeAccordion($panel, $panel.prev(), true);
		});
	},


	/**
  *
  * @param {Object} panel The accordion content.
  * @param {Object} toggle The accordion title.
  * @param {boolean} [silent] Indicates whether the accordion should be closed without an animation.
  *
  * @returns {void}
  */
	closeAccordion: function closeAccordion(panel, toggle, silent) {
		panel.removeClass(this._stateClasses.open);
		toggle.removeClass(this._stateClasses.open);

		panel.addClass(this._stateClasses.closed);
		toggle.addClass(this._stateClasses.closed);
		if (!silent) {
			toggle.slideUp();
		} else {
			panel.hide();
		}
	},


	/**
  *
  * @param {Object} panel The accordion content.
  * @param {Object} toggle The accordion title.
  * @param {boolean} [silent] Indicates whether the accordion should be opened without an animation.
  *
  * @returns {void}
  */
	openAccordion: function openAccordion(panel, toggle, silent) {
		panel.addClass(this._stateClasses.open);
		toggle.addClass(this._stateClasses.open);

		panel.removeClass(this._stateClasses.closed);
		toggle.removeClass(this._stateClasses.closed);
		panel.show();
		if (!silent) {
			panel.slideDown();
		}
	},
	openAccordionFor: function openAccordionFor(newsItem) {
		var panel = newsItem.parent().parent();
		var toggle = panel.prev();

		if (!panel.hasClass(this._stateClasses.open)) {
			this.openAccordion(panel, toggle, true);
		}
	},
	resetAccordions: function resetAccordions() {
		var _this4 = this;

		this.closeAccordions();

		// Open the ones that were open at the beginning again
		var initiallyOpenPanels = this.$ctx.find(this._stateClasses.initiallyOpen);

		initiallyOpenPanels.map(function (index, element) {
			var $panel = $(element);
			return _this4.openAccordion($panel, $panel.prev(), true);
		});
	},
	showInitialSelection: function showInitialSelection() {
		this.$items.show();
		this.resetAccordions();
	},
	onSearchClosed: function onSearchClosed() {
		this.showInitialSelection();
	},


	/**
  * Event when the user searched the displayed items
  *
  * @param {string} value The value to search for
  * @returns {void}
  */
	onFilterChange: function onFilterChange(value) {
		var _this5 = this;

		if (value.length < 3) {
			if (value.length === 0) {
				this.showInitialSelection();
			}
			return;
		}

		var results = this.lunr.search(value);

		this.$items.hide();

		this.closeAccordions();

		results.map(function (newsStoreObject) {
			var newsItem = _this5.$ctx.find('#' + newsStoreObject.ref);
			_this5.openAccordionFor(newsItem);
			return newsItem.show();
		});
	}
});